import React, { Component } from 'react';

var KiotSpinner = null;
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import { Rating } from 'material-ui-rating'
import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;

export default class PreviewFeedbackForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: this.props.form
        }
    }


    render() {
        return (
            <div>{this.state.form &&
                <Box header={"Form Preview"}>

                    <h3>{this.state.form.title}</h3>
                    {this.state.form.description && <h6>{this.state.form.description}</h6>}
                    <br />

                    {this.state.form.survey_sections &&
                        this.state.form.survey_sections.map((sec, s_ind) => {
                            return <div className="m-1-vw" key={s_ind + " psection"}>
                                <h5>{sec.title}</h5>
                                {sec.description && <h6>{sec.description}</h6>}
                                <div className="m-1vw">
                                    {
                                        sec.questions && sec.questions.length &&
                                        sec.questions.map((qn, q_ind) => {
                                            return <div key={q_ind + " pqn"}>
                                                <h6 style={{ marginBottom: "0px" }}>{qn.title} {qn.is_required && "*"}</h6>
                                                {
                                                    (() => {
                                                        switch (qn.field_type) {
                                                            case "shortanswer": {
                                                                return <TextField
                                                                    className="w-100"
                                                                />
                                                            }
                                                            case "longanswer": {
                                                                return <TextField
                                                                    multiLine={true}
                                                                    className="w-100"
                                                                    rows={4} />
                                                            }
                                                            case "rating": {
                                                                return <Rating
                                                                    value={qn.rating_value}
                                                                    max={qn.stars || 5}
                                                                    onChange={(value) => {
                                                                        let form = this.state.form;
                                                                        form.survey_sections[s_ind].questions[q_ind].rating_value = value;
                                                                        this.setState({
                                                                            form
                                                                        })

                                                                    }}
                                                                />
                                                            }
                                                            case "multiplechoice": {
                                                                return <RadioButtonGroup className="m-1vw">
                                                                    {qn.options.map((op, oind) => {
                                                                        return <RadioButton
                                                                            key={oind + "selectop"}
                                                                            label={op.option}
                                                                            value={op.option}
                                                                        />
                                                                    })
                                                                    }
                                                                </RadioButtonGroup>
                                                            }
                                                            case "checkbox": {
                                                                return <div className="m-1vw">{qn.options.map((op, oind) => {
                                                                    return <Checkbox
                                                                        key={oind + "checkop"}
                                                                        label={op.option}
                                                                    />
                                                                })}</div>

                                                            }
                                                            case "dropdown": {
                                                                return <SelectField
                                                                    value={qn.select_ans}
                                                                    floatingLabelText={"Choose your answer"}
                                                                    className="w-100"
                                                                    onChange={(e, i, val) => {
                                                                        let form = this.state.form;
                                                                        debugger;
                                                                        form.survey_sections[s_ind].questions[q_ind].select_ans = val;
                                                                        this.setState({
                                                                            form
                                                                        })
                                                                    }} >
                                                                    {qn.options.map((op, oind) => {
                                                                        return <MenuItem key={oind + "dropdownop"} primaryText={op.option} value={op.option} />
                                                                    })}
                                                                </SelectField>
                                                            }
                                                            case "date": {
                                                                return <DatePicker
                                                                    hintText="Enter Date"
                                                                    container="inline"
                                                                    className="w-100"
                                                                    autoOk />
                                                            }
                                                            case "time": {
                                                                return <TimePicker
                                                                    format="ampm"
                                                                    autoOk
                                                                    hintText="Enter Time"
                                                                />
                                                            }
                                                        }
                                                    })()
                                                }
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }



                    <RaisedButton
                        label="Close Preview"
                        primary
                        className="pull-right"
                        onClick={() => { this.props.unMountMe() }}
                        type="button"
                    />
                </Box>
            }
            </div>)
    }
}


// WEBPACK FOOTER //
// ./components/feedback/PreviewFeedbackForm.js